/**
 * @fileoverview Regras puras dos templates da API oficial nas telas de envio
 * automático (lembretes e contato ativo da triagem, abordagens inteligentes):
 * o corpo do template, por que ele não pode sair sozinho, a prévia com dados de
 * exemplo e a variável que ficou sem origem. Uma cópia só, usada pelas duas
 * telas (o backend tem a mesma regra em rules/outreachRules.ts).
 */

import { extractTemplateVars } from "./templateVars";

const componentOf = (tpl, type) => (tpl?.components || []).find((c) => c.type === type);

/** Texto do corpo do template ("" se não houver). */
export const templateBodyText = (tpl) => componentOf(tpl, "BODY")?.text || "";

const ACCEPTED_BUTTONS = ["QUICK_REPLY", "PHONE_NUMBER", "URL"];

/**
 * Por que o template não pode sair sozinho (null: pode), como chave:
 * authTemplate, namedVariable, mediaHeader, headerVariable, codeButton ou
 * urlVariable. O envio automático só preenche variáveis numeradas do corpo.
 * Cada tela traduz a chave com o próprio texto.
 */
export const templateProblemKey = (tpl) => {
  if (String(tpl?.category || "").toUpperCase() === "AUTHENTICATION") return "authTemplate";
  if (String(tpl?.parameter_format || "").toUpperCase() === "NAMED" || /\{\{\s*[A-Za-z_]/.test(templateBodyText(tpl))) {
    return "namedVariable";
  }
  const header = componentOf(tpl, "HEADER");
  if (header && header.format && header.format !== "TEXT") return "mediaHeader";
  if (header && extractTemplateVars(header.text).length) return "headerVariable";
  const buttons = componentOf(tpl, "BUTTONS")?.buttons || [];
  if (buttons.some((b) => !ACCEPTED_BUTTONS.includes(String(b?.type || "").toUpperCase()))) return "codeButton";
  if (buttons.some((b) => /\{\{/.test(String(b?.url || "")))) return "urlVariable";
  return null;
};

/**
 * Corpo do template com cada variável trocada pelo exemplo da origem escolhida
 * (`sources`: `{ value, example }`) ou pelo texto fixo. Sem exemplo, a variável
 * fica como está.
 */
export const previewText = (tpl, variables, sources) =>
  templateBodyText(tpl).replace(/\{\{(\d+)\}\}/g, (all, n) => {
    const source = variables?.[n] || "";
    if (source.startsWith("fixed:")) return source.slice(6) || all;
    return sources.find((s) => s.value === source)?.example || all;
  });

/** Primeira variável sem valor (`kind`: sem origem ou texto fixo vazio); null: todas têm. */
export const missingVariable = (template) => {
  for (const [n, source] of Object.entries(template?.variables || {})) {
    if (!source) return { n, kind: "variable" };
    if (source.startsWith("fixed:") && !source.slice(6).trim()) return { n, kind: "fixed" };
  }
  return null;
};
